<script>
import { mapActions, mapState } from "vuex";

import orderMixin from "@/mixins/orderMixin";

export default {
  mixins: [orderMixin],

  data() {
    return {
      couponName: "",
      error: null
    };
  },

  methods: {
    ...mapActions("payable", ["checkCoupon", "applyCoupon", "removeCoupon"]),

    async applyPayableCoupon() {
      this.error = null;

      if (!this.couponName) {
        return;
      }

      try {
        const coupon = await this.checkCoupon(this.couponName);

        if (coupon) {
          await this.applyCoupon(coupon.id);
        }
      } catch (e) {
        this.error = e;
      }
    },

    async removePayableCoupon() {
      if (!this.coupon) return;

      try {
        await this.removeCoupon();
      } catch (e) {
        this.error = "não foi possível remover o cupom";
      }
    }
  },

  computed: {
    ...mapState("payable", ["payable", "preloaderCoupon", "accountBonus"]),

    coupon: function() {
      return this.payable.coupon;
    }
  }
};
</script>

<template>
  <div class="coupon">
    <h4>Cupom promocional</h4>

    <div v-if="coupon">
      <p>
        Cupom <span>{{ payable | getOrderCouponName }} ({{ payable | getOrderCouponDiscount }})</span> aplicado.
      </p>

      <form class="remove-forms" @submit.prevent="removePayableCoupon" >
        <button
          class="custom-button button-remove"
          type="submit"
          :disabled="preloaderCoupon"
          :class="{ 'button-disabled': preloaderCoupon, 'button-loading': preloaderCoupon }"
        >
          <span :class="{ 'disabled': preloaderCoupon }">REMOVER CUPOM</span>
        </button>
        <div class="amount">- {{ payable | getOrderCouponDiscountAmount }}</div>
      </form>
    </div>

    <form v-else @submit.prevent="applyPayableCoupon">
      <input
        v-model="couponName"
        type="text"
        placeholder="informe o cupom"
        :disabled="accountBonus"
      />

      <button
        class="custom-button"
        type="submit"
        :disabled="preloaderCoupon || accountBonus"
        :class="{ 'button-disabled': preloaderCoupon || accountBonus, 'button-loading': preloaderCoupon }"
      >
        <span :class="{ 'disabled': preloaderCoupon }">APLICAR</span>
      </button>
    </form>

    <div class="warning" v-if="error">{{error}}</div>
  </div>
</template>

<style scoped>
.coupon {
  border-bottom: solid 1px #e2e2e2;
  margin-bottom: 8px;
  padding-bottom: 8px;
}

h4 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 400;
  color: #424242;
}

p {
  margin: 8px 0;
  font-size: 13px;
  font-weight: 300;
  color: #888;
}

span {
  font-weight: 500;
}

.amount {
  width: 100%;
  font-weight: 500;
  text-align: end;
  color: #af006b;
}

form {
  display: flex;
  flex-direction: row;
}

input {
  width: calc(100% - 36px - 2px);
  height: 32px;
  padding: 0 0 0 36px;
  background: url("/static/cupom.svg") no-repeat 10px 10px;
  background-size: 20px 17px;
  text-transform: uppercase;
  line-height: 32px;
  border: 1px solid #ddd;
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

input::placeholder {
  text-transform: lowercase;
}

button {
  width: 100%;
  max-width: 100%;
  height: 37px;
  margin-top: 8px;
  border: 0;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #af006b;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
}

button:hover {
  background-color: var(--pink-dark);
}

.button-disabled {
  opacity: 0.25;
}

.disabled {
  display: none;
}

.button-loading:before {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 24px;
  background-clip: padding-box;
  border: rgba(255, 255, 255, 0.25) 2px solid;
  border-top-color: #fff;
  animation: animation-rotate 750ms linear infinite;
}

.button-loading span,
.button-loading:hover span,
.button-loading:active span {
  display: none;
}

.warning {
  margin-top: 12px;
  border-left: solid 1px #af006b;
  color: #af006b;
  padding-left: 8px;
  font-size: 12px;
}

.custom-button {
  width: 50%;
  max-width: 150px;
  margin: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.remove-forms {
  align-items: center;
}

.button-remove {
  height: 30px;
}

@keyframes animation-rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payable/OrderComponents/Coupon.vue